import {
  GetCCSReportRequestPayload,
  GetDebtAccrualsRequestPayload,
  GetDebtStatementRequestPayload,
  GetDebtUpcomingCashflowsRequestPayload,
  GetDebtValuationRequestPayload,
  GetIFRSReportRequestPayload,
  GetScenarioAnalysisDownloadSuccessPayload,
  GetUpcomingCashflowsRequestPayload,
} from '@/pages/EntityPortfolio/store/actions';
import { AxiosInstance } from 'axios';

export default class ReportAPI {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }
  async downloadScenarioAnnalysisReport(
    payload: GetScenarioAnalysisDownloadSuccessPayload,
  ) {
    return this.client.post(
      '/v2/reporting/download-scenario-analysis-report',
      payload,
    );
  }
  async downloadUpcomingCashFlowsReport(
    payload: GetUpcomingCashflowsRequestPayload,
  ) {
    return this.client.post(
      '/v2/reporting/download-upcoming-cashflows-report/',
      payload,
    );
  }

  async downloadDebtValuationReport(payload: GetDebtValuationRequestPayload) {
    return this.client.post(
      '/v2/reporting/download-debt-valuation-report/',
      payload,
    );
  }

  async downloadDebtStatementReport(payload: GetDebtStatementRequestPayload) {
    return this.client.post(
      '/v2/reporting/download-debt-statement-report/',
      payload,
    );
  }

  async downloadDebtUpcomingCashflowsReport(
    payload: GetDebtUpcomingCashflowsRequestPayload,
  ) {
    return this.client.post(
      '/v2/reporting/download-debt-upcoming-cashflows-report',
      payload,
    );
  }

  async downloadIFRSReport(payload: GetIFRSReportRequestPayload) {
    return this.client.post('/v2/reporting/download-ifrs-report/', payload);
  }
  async downloadCCSReport(payload: GetCCSReportRequestPayload) {
    return this.client.post('/v2/reporting/download-ccs-report/', payload);
  }

  async downloadDebtAccrualsReport(payload: GetDebtAccrualsRequestPayload) {
    return this.client.post(
      '/v2/reporting/download-debt-accruals-report/',
      payload,
    );
  }
}
